module.exports = __webpack_public_path__ + "img/garage.ee54065b.svg";